"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceItemAdapter = void 0;
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var source_adapter_1 = require("./source-adapter");
var model_js_1 = require("@cognitoforms/model.js"); // eslint-disable-line import/no-duplicates
var helpers_1 = require("./helpers");
// @ts-ignore
var SourceItemAdapter = /** @class */ (function (_super) {
    __extends(SourceItemAdapter, _super);
    function SourceItemAdapter() {
        var _this_1 = _super !== null && _super.apply(this, arguments) || this;
        _this_1.isOrphaned = false;
        _this_1.internalIndex = -1;
        _this_1.isSubscribedToSourceChanges = false;
        return _this_1;
    }
    SourceItemAdapter.prototype.created = function () {
        // Track the intial index internally
        this.internalIndex = this.index;
        // Track changes to the list and update the component's state appropriately
        if (!this.suppressChangeTracking) {
            this.subscribeToSourceChanges();
        }
    };
    SourceItemAdapter.prototype.onIndexChanged = function (index) {
        this.internalIndex = index;
    };
    Object.defineProperty(SourceItemAdapter.prototype, "parent", {
        get: function () {
            if ((0, source_adapter_1.isSourceAdapter)(this.parentSource)) {
                return this.parentSource;
            }
            for (var parentVm = this.$parent.$parent, parentLevel = 1; parentVm != null; parentVm = parentVm.$parent, parentLevel += 1) {
                if ((0, source_adapter_1.isSourceAdapter)(parentVm.$source)) {
                    return parentVm.$source;
                }
            }
            throw new Error("Parent source not found!");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourceItemAdapter.prototype, "readonly", {
        /**
         *  Indicants whether the source property is readonly.
         *
         *  @returns True if either the parent source or the source override is read only, otherwise false
         */
        get: function () {
            return this.parent.readonly || (this.overrides ? this.overrides.readonly : false);
        },
        enumerable: false,
        configurable: true
    });
    SourceItemAdapter.prototype.subscribeToSourceChanges = function () {
        if (this.isSubscribedToSourceChanges) {
            return;
        }
        var _this = this;
        var array = model_js_1.ObservableArray.ensureObservable(this.parent.value);
        array.changed.subscribe(function (args) {
            var index = _this.internalIndex;
            var isOrphaned = _this.isOrphaned;
            args.changes.forEach(function (c) {
                if (c.type === model_js_1.ArrayChangeType.remove) {
                    if (c.startIndex === index) {
                        index = -1;
                        isOrphaned = true;
                    }
                    else if (c.startIndex < index) {
                        if (c.items.length > index - c.startIndex) {
                            index = -1;
                            isOrphaned = true;
                        }
                        else {
                            index -= c.items.length;
                        }
                    }
                }
                else if (c.type === model_js_1.ArrayChangeType.add) {
                    if (c.startIndex >= 0) {
                        if (c.startIndex <= index) {
                            index += c.items.length;
                        }
                    }
                }
            });
            if (isOrphaned !== _this.isOrphaned) {
                vue_1.default.set(_this, "isOrphaned", isOrphaned);
            }
            if (index !== _this.internalIndex) {
                vue_1.default.set(_this, "internalIndex", index);
            }
        });
        this.isSubscribedToSourceChanges = true;
    };
    Object.defineProperty(SourceItemAdapter.prototype, "value", {
        get: function () {
            var list = this.parent.value;
            var value = list[this.internalIndex];
            return value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourceItemAdapter.prototype, "type", {
        get: function () {
            // If possible, determine the type based on the actual entity instance
            if (this.value && (0, helpers_1.isEntity)(this.value))
                return this.value.meta.type.jstype;
            return this.parent.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourceItemAdapter.prototype, "isList", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SourceItemAdapter.prototype, "displayValue", {
        get: function () {
            var list = this.parent.value;
            var value = list[this.internalIndex];
            var displayValue;
            if ((0, source_adapter_1.isSourcePropertyAdapter)(this.parent) && this.parent.property.format != null) {
                // Use a markup or property format if available
                displayValue = this.parent.property.format.convert(value);
            }
            else {
                displayValue = value.toString();
            }
            return displayValue;
        },
        enumerable: false,
        configurable: true
    });
    SourceItemAdapter.prototype.toString = function () {
        return "Source[" + this.internalIndex + "]";
    };
    __decorate([
        (0, vue_property_decorator_1.Prop)(Number),
        __metadata("design:type", Number)
    ], SourceItemAdapter.prototype, "index", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)(Object),
        __metadata("design:type", Object)
    ], SourceItemAdapter.prototype, "parentSource", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)(Object),
        __metadata("design:type", Object)
    ], SourceItemAdapter.prototype, "overrides", void 0);
    __decorate([
        (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false }),
        __metadata("design:type", Boolean)
    ], SourceItemAdapter.prototype, "suppressChangeTracking", void 0);
    __decorate([
        (0, vue_property_decorator_1.Watch)("index"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", void 0)
    ], SourceItemAdapter.prototype, "onIndexChanged", null);
    SourceItemAdapter = __decorate([
        vue_property_decorator_1.Component
    ], SourceItemAdapter);
    return SourceItemAdapter;
}(vue_1.default));
exports.SourceItemAdapter = SourceItemAdapter;
